import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Simplecontact from '../components/simplecontact';
import SEO from '../components/SEO';

const ContactUs = () => {
  // Schema.org structured data for contact page
  const contactSchema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact Robomec Automation",
    "description": "Get in touch with Robomec Automation for industrial automation solutions, product inquiries, or support.",
    "url": "https://www.robomecautomation.com/contact-us",
    "mainEntity": {
      "@type": "Organization",
      "name": "Robomec Automation Private Limited",
      "telephone": "+91-XXXXXXXXXX",
      "email": "info@robomecautomation.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "B133, Opp Sukrut Company, Near Bharat Petroleum Pump, Bhambholi, Chakan",
        "addressLocality": "Pune",
        "postalCode": "410501",
        "addressCountry": "IN"
      }
    }
  };

  return (
    <>
      <SEO 
        title="Contact Us"
        description="Get in touch with Robomec Automation for industrial automation solutions, product inquiries, or support. We're here to help with your manufacturing needs."
        canonicalUrl="https://www.robomecautomation.com/contact-us"
        keywords={[
          "contact Robomec Automation",
          "industrial automation support",
          "manufacturing solutions inquiry",
          "automation consultation",
          "Pune automation company"
        ]}
        schema={contactSchema}
      />
      <div>
        <Container fluid className="py-5">
          <Row className="text-center justify-content-center">
            <Col md={8}>
              <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>
                We measure our success with yours!
              </h1>
              <p style={{ fontSize: '1.25rem', marginTop: '1rem' }}>
                Let's connect and discuss how we can help you achieve your goals.
              </p>
            </Col>
          </Row>
        </Container>
        <Simplecontact />
      </div>
    </>
  );
};

export default ContactUs;
